import React from "react";
import { HomeCarousel } from "components/HomeCarousel";
import { breakpointsInPx, useScreenViewport } from "lib/checkViewport";
import { carouselWrapper } from "./Carousel.css";
import { colours } from "@shared/ui.design-system";

type ItemsToShow = {
  slidesPerView?: number;
  slidesPerGroup?: number;
};

type Props = {
  carouselProps?: {
    showArrows?: boolean;
    carouselWrapperClassName?: string;
    itemsToShow?: ItemsToShow;
    showScrollbar?: boolean;
    gap?: number;
    pagination?: boolean | Record<string, string | boolean>;
  };
  children: React.ReactNode[];
};

export const Carousel: React.FC<Props> = ({ children, carouselProps = {} }) => {
  const { isMobile } = useScreenViewport();

  const {
    showArrows = !isMobile,
    carouselWrapperClassName,
    showScrollbar,
    itemsToShow,
    gap,
    pagination = false
  } = carouselProps;

  return (
    <div className={carouselWrapperClassName ?? carouselWrapper}>
      <HomeCarousel
        gap={gap ?? 20}
        arrowsShadow={false}
        arrowsColor={colours.primary.medium}
        prevBtnStyles={{
          left: "-3.5rem !important" // We are using !important to override <HomeCarousel> styles which do contain !important declaration as well
        }}
        nextBtnStyles={{
          right: "-3.5rem !important" // We are using !important to override <HomeCarousel> styles which do contain !important declaration as well
        }}
        arrowsLocation="external"
        containerProps={{
          pb: 1
        }}
        centeredSlides={false}
        loop={false}
        scrollbar={showScrollbar ?? isMobile}
        pagination={pagination}
        showNavigation={showArrows}
        breakpoints={
          itemsToShow ?? {
            [breakpointsInPx.sm]: {
              slidesPerView: 3,
              slidesPerGroup: 1
            },
            [breakpointsInPx.xs]: {
              slidesPerView: 2.2,
              slidesPerGroup: 2
            }
          }
        }
      >
        {children}
      </HomeCarousel>
    </div>
  );
};
